import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";

/* Testimonials intentionally left as an elegant placeholder.
   Real client stories to be added later. */
export default function Testimonials() {
  return (
    <section className="bg-[#F9FAFB] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Client Voices</Eyebrow>
          <div className="mt-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-display max-w-2xl text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0B1F3A]">
              Stories from those we've helped move forward.
            </h2>
            <p className="max-w-md text-base leading-relaxed text-[#4B5563]">
              We're gathering reflections from the students, professionals and founders
              we work with. Featured stories are coming soon.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <Reveal key={i} delay={0.06 * i}>
              <div
                data-testid={`testimonial-placeholder-${i}`}
                className="flex h-full min-h-[220px] flex-col justify-between rounded-2xl border border-dashed border-[#0B1F3A]/15 bg-white/60 p-8"
              >
                <Quote className="h-8 w-8 text-[#C8A75D]/50" />
                <div className="space-y-2.5">
                  <div className="h-2.5 w-full rounded-full bg-[#0B1F3A]/5" />
                  <div className="h-2.5 w-5/6 rounded-full bg-[#0B1F3A]/5" />
                  <div className="h-2.5 w-2/3 rounded-full bg-[#0B1F3A]/5" />
                </div>
                <p className="text-xs uppercase tracking-[0.18em] text-[#0B1F3A]/30">
                  Coming soon
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
